import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';
import { AndroidIcon, AppleIcon } from '../ui/PlatformIcons';

const MANAGER_URL = 'https://t.me/BandaApps_Manager';

export const Pricing = ({ t }) => {
  const platforms = [
    { name: 'Android', price: t('pricing.androidPrice'), Icon: AndroidIcon, modifier: 'android' },
    { name: 'iOS', price: t('pricing.iosPrice'), Icon: AppleIcon, modifier: 'ios' },
  ];

  return (
    <section className="section pricing" id="apps">
      <Reveal>
        <SectionHeading eyebrow={t('pricing.eyebrow')} title={t('pricing.title')} />
      </Reveal>

      <div className="pricing__grid">
        {platforms.map((platform, index) => (
          <Reveal key={platform.name} delay={index * 120}>
            <article className={`platform-card platform-card--${platform.modifier}`}>
              <div className="platform-card__top">
                <span className="platform-card__number">{`0${index + 1}`}</span>
                <span className="platform-card__badge"><platform.Icon /></span>
              </div>

              <h3>{platform.name}</h3>

              <div className="platform-card__price">
                <span className="platform-card__price-label">{t('pricing.priceLabel')}</span>
                <strong>{platform.price}</strong>
              </div>

              <ul>
                {t('pricing.features').map((feature) => <li key={feature}>{feature}</li>)}
              </ul>

              <a href={MANAGER_URL} target="_blank" rel="noreferrer">
                {t('pricing.cta')}
              </a>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
